////////////////////////////////////////////////////////////////// IE SUPPORT
import 'babel-polyfill'
// import 'default-passive-events'

////////////////////////////////////////////////////////////////// VUE COMPONENTS
import BgImage from './components/bg-image/bg-image.vue'
import NewsletterForm from './components/newsletter-form/newsletter-form.vue'
import CookiesMsg from './components/cookies-msg/cookies-msg.vue'
import SideMenu from './components/side-menu/side-menu.vue'

////////////////////////////////////////////////////////////////// VUE PLUGINS
import FancyBox from './plugins/fancy-box'
Vue.use(FancyBox)

import './expertise'
import './career'
import './map'
import './people'
import './news'
import './contact'
// import './jobs-popup'

import Slick from 'vue-slick'
import VueScrollTo from 'vue-scrollto'

////////////////////////////////////////////////////////////////// APP

const scrollOptions = {
    container: "body",
    easing: "ease-out",
    duration: 1000,
    offset: -62,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
}

Vue.use(VueScrollTo, scrollOptions);

var app = new Vue({
    el: '#app',
    components: {
        BgImage,
        NewsletterForm,
        Slick,
        CookiesMsg,
        SideMenu
    },
    data() {
        return {
            scrolled: false,
            mobMenuOpen: false,
            scrollDisabled: false,
        }
    },
    methods: {
        onScroll() {
            this.scrolled = window.pageYOffset > 0;
        },
        toggleScroll() {
            this.fixScrollbarShifting();
            if (this.scrollDisabled) {
                $('body').addClass('fancybox-active compensate-for-scrollbar');
            } else {
                $('body').removeClass('fancybox-active compensate-for-scrollbar');
            }
        },
        toggleSideMenu() {
            this.mobMenuOpen = !this.mobMenuOpen;
            this.scrollDisabled = !this.scrollDisabled;
            this.toggleScroll();
        },
        fixedElement() {
            $('.fixed-el').scrollToFixed({
                marginTop: 100,
                limit: function () {
                    var limit = $('footer').offset().top - $(this).outerHeight() - 60;
                    return limit;
                },
                zIndex: 10,
                minWidth: 975
            });
        },
        goToTop() {
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
        },
        // fancybox(event) {
        //     var src = event.target.getAttribute("fancybox-src");
        //     $.fancybox.open({
        //         src: src,
        //         type: 'inline',
        //         opts: {
        //             infobar: false,
        //             loop: true,
        //             protect: false,
        //             animationEffect: "fade",
        //             // spinnerTpl: '<div class="fancybox-loading"></div>',
        //             toolbar: "auto",
        //             smallBtn: true,
        //             touch: true,
        //             // btnTpl: {
        //             //     arrowLeft: `
        //             //     <a data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" href="javascript:;">
        //             //         <i class="icon-arrow_left icon-xl"></i>
        //             //     </a>`,
        //             //     arrowRight: `
        //             //     <a data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" href="javascript:;">
        //             //         <i class="icon-arrow_right icon-xl"></i>
        //             //     </a>`,
        //             //     smallBtn: `
        //             //     <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
        //             //         <i class="icon-close-white icon-xl"></i>
        //             //     </button>`
        //             // },
        //         }
        //     });
        // },
        getScrollbarWidth() {
            var outer = document.createElement("div");
            outer.style.visibility = "hidden";
            outer.style.width = "100px";
            outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

            document.body.appendChild(outer);

            var widthNoScroll = outer.offsetWidth;
            // force scrollbars
            outer.style.overflow = "scroll";

            // add innerdiv
            var inner = document.createElement("div");
            inner.style.width = "100%";
            outer.appendChild(inner);

            var widthWithScroll = inner.offsetWidth;

            // remove divs
            outer.parentNode.removeChild(outer);

            return widthNoScroll - widthWithScroll;
        },
        fixScrollbarShifting() {
            var $style = $('#fancybox-style-noscroll');
            var isStyled = $style.length;

            if (isStyled) {
                $style.remove();
            } else {
                $('head').append(`
                    <style id="fancybox-style-noscroll" type="text/css">
                        .compensate-for-scrollbar{
                            margin-right:${this.getScrollbarWidth()}px;
                        }
                    </style>
                `);
            }
        },
        scrollTo(el) {
            this.$scrollTo(el, 1000, scrollOptions)
        }
    },
    created() {
        this.scrolled = window.pageYOffset > 0;
        window.addEventListener('scroll', this.onScroll, {
            passive: true
        });
    },
    mounted() {

        if (location.hash) {
            this.$scrollTo(location.hash, 1000, scrollOptions)
        }

        this.fixedElement()
        // GLOBAL OPTIONS FOR FANCYBOX
        // $('[data-fancybox-inline]').fancybox({
        //     touch: false,
        //     smallBtn: true,
        //     btnTpl: {
        //         smallBtn: `
        //         <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
        //             <i class="icon-close"></i>
        //         </button>
        //         `,
        //     },
        // });

        // $('[data-fancybox-image]').fancybox({
        //     touch: false,
        //     smallBtn: true,
        //     btnTpl: {
        //         smallBtn: `
        //         <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
        //             <i class="icon-close"></i>
        //         </button>
        //         `,
        //     },
        // });
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll);
    }
})


// WEBPACK FOOTER //
// ./src/js/app.js